import { Badge } from '@/components/ui/Badge';
import { ACCOUNT_TYPE_LABELS, type AccountType } from '@/types/accounting';

const TONES: Record<AccountType, 'brass' | 'danger' | 'info' | 'success' | 'warning'> = {
  asset:     'brass',
  liability: 'danger',
  equity:    'info',
  revenue:   'success',
  expense:   'warning',
};

export function AccountTypeBadge({ type }: { type: AccountType }) {
  return <Badge tone={TONES[type]}>{ACCOUNT_TYPE_LABELS[type]}</Badge>;
}
